import get from "lodash/get";

import type { JollyRancherChipColor } from "veneer/Chip";

import { User } from "cortex/ui/src/user/model";

import { ROLE } from "./app";

type RoleCode = (typeof ROLE)[keyof typeof ROLE];

export type RoleProps = {
  label: string;
  labelColor?: JollyRancherChipColor;
};

const ROLE_PROPS: Record<RoleCode, RoleProps> = {
  [ROLE.ADMIN]: { label: "Full access", labelColor: "red" },
  [ROLE.DISABLED]: { label: "Disabled", labelColor: "gray" },
  [ROLE.OPERATOR]: { label: "Operator", labelColor: "yellow" },
  [ROLE.READ_ONLY]: { label: "Read only", labelColor: "green" },
  [ROLE.SUB_ACCOUNT]: { label: "Sub account", labelColor: "blue" },
  [ROLE.ADMIN_OPERATOR]: { label: "Admin operator", labelColor: "orange" },
  [ROLE.UNKNOWN]: { label: "Unknown", labelColor: "gray" },
};

function getRoleProp(user: User): RoleProps {
  // Checks disabled value since the role values do not match the labels.
  if (user.disabled) {
    return ROLE_PROPS[ROLE.DISABLED];
  }

  return get(
    ROLE_PROPS,
    user.role || ROLE.UNKNOWN,
    ROLE_PROPS[ROLE.UNKNOWN],
  ) as RoleProps;
}

export { getRoleProp };
